import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';
import { FaCheck } from 'react-icons/fa'
import bgMobile from '../../assets/images/bg_mobile.png';
import bgWide from '../../assets/images/bg_wide.png';

interface TipGroupProps {
  isSelected: boolean
}

interface AnalystContainerProps {
  color: string;
}

interface CheckProps {
  checked: boolean
}

export const Container = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  
  background-image: url(${bgMobile});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed; /* Keeps bg fixed during scroll if needed, though container is overflow hidden */

  @media (min-width: 768px) {
    background-image: url(${bgWide});
  }
`;

export const MainBody = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const CalendarContainer = styled.div`
  width: 98%;
  max-width: 1800px;
  margin: 1rem auto 2rem auto; /* Adjusted margins */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 2rem;
  overflow: hidden; /* Prevent scroll */
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  flex: 1; /* Take remaining height */

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: #EEEEEE;
    border-radius: 20px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #CCCCCC;
    border-radius: 20px;
    border: 3px solid #EEEEEE;
  }
`;

export const Calendar = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* FullCalendar Overrides */
  .fc {
    font-family: inherit;
    height: 100%; /* Fill container */
  }

  .fc-view-harness {
    flex: 1;
    overflow: hidden;
  }

  .fc-col-header-cell {
    background-color: #fafafa;
    padding: 10px 0;
    border-bottom: 2px solid #54278b;
  }

  .fc-col-header-cell-cushion {
    text-transform: uppercase;
    font-weight: 700;
    color: #54278b;
    text-decoration: none;
  }

  .fc-theme-standard td, .fc-theme-standard th {
    border-color: #eee;
  }

  .fc-day-today {
    background-color: rgba(84, 39, 139, 0.04) !important;
  }

  .fc-daygrid-day-number {
    color: #666;
    font-weight: 600;
    text-decoration: none;
    padding: 8px;
  }

  .fc-h-event {
    border: none;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }

  .fc-daygrid-more-link {
    color: #54278b;
    font-weight: bold;
    text-decoration: none;
  }
`;

export const Load = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Checkbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  width: 1.3em;
  height: 1.3em;
  background-color: white;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
`;

export const Checkmark = styled(FaCheck) <CheckProps>`
  color: ${styleSheet.colorMain};
  display: ${({ checked }) => checked ? 'flex' : 'none'};
`;

export const Tips = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 3.5rem;
`;

export const Title = styled.h3`
  font-size: 1.6rem;
  font-weight: 400;
  color: #54278b;
  margin: 0 1rem 0 0; /* Clear vertical margins */
  padding: 0;
  display: flex; /* Ensure clear flex box behavior */
  align-items: center;
  height: 100%; /* Match parent height if set, or just behave nicely */
`;

export const TipGroup = styled.button<TipGroupProps>`
  display: flex;
  width: 120px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  padding: 5px 4px;
  /* border: 1px solid ${styleSheet.titleLight}; */
  /* border-radius: 6px; */

  color: ${styleSheet.shapeDark};
  font-weight: ${({ isSelected }) => isSelected ? 'bold' : 'normal'};
  font-size: ${({ isSelected }) => isSelected ? '1.6rem' : '1.4rem'};
`;

export const Tip = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.span`
  font-size: 1.2rem;
  margin-left: .3rem;
`;

export const Receive = styled.p`
  width: 100%;
  font-size: 2rem;
  font-weight: bold;
  border-top: 1px #ccc solid;
  padding-top: 1rem;
  margin-bottom: 1rem;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  z-index: 99;
`;

export const SelectAnalystContainer = styled.div`
  background-color: ${styleSheet.shape};
  display: block;
  position: fixed;
  width: 40%;
  height: auto;
  max-height: 60%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: black;
  border-radius: 12px;
  z-index: 999;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);

  ::-webkit-scrollbar {
    width: 6px;     
  }

  ::-webkit-scrollbar-track {
    background: #EEEEEE;    
    border-radius: 20px;       

  }

  ::-webkit-scrollbar-thumb {
    background-color: #CCCCCC;    
    border-radius: 20px;       
    border: 3px solid #EEEEEE;  
  }
`;

export const SelectAnalystContent = styled.div`
  padding: 3rem;
  display: flex;
  flex-wrap: wrap;
`;

export const AnalystContainer = styled.button<AnalystContainerProps>`
  padding: 1rem 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  margin-right: 2rem;
  background-color: ${({ color }) => color};
  border-radius: 5px;
  border: 0;
  cursor: pointer;
`;

export const AnalystName = styled.span`
  font-size: 1.6rem;
`;

export const DetailContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Detail = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetailText = styled.span`
  font-size: 1.4rem;
`;

export const PeriodHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  gap: 20px; 
  padding: 1rem 0;
  background: transparent;
  width: 100%;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
  z-index: 20;

  /* Override Semantic UI Dropdown styles within this header */
  .ui.selection.dropdown {
    border: none !important;
    border-radius: 0;
    box-shadow: none !important;
    background: transparent !important;
    color: #54278b !important; /* Make text purple to stand out */
    padding: 0.8em 0 !important; /* Remove side padding */
    min-width: auto !important;
    width: fit-content !important;
    display: inline-flex !important;
    align-items: center;

    /* Adjust arrow position */
    .dropdown.icon {
      position: relative !important;
      top: auto !important;
      right: auto !important;
      margin: 0 0 0 10px !important;
      padding: 0 !important;
      opacity: 1 !important;
    }

    .text {
       font-weight: 500 !important;
    }

    &:hover {
      border: none !important;
    }
    
    &.active, &.visible {
      border: none !important;
      .menu {
        border: 1px solid #eee;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        margin-top: 5px;
      }
    }
  }
`;